module.exports = __webpack_public_path__ + "static/media/kalenday.3fd799dc.svg";